import { render, staticRenderFns } from "./ModalForgetPass.vue?vue&type=template&id=03c03c25&scoped=true&"
import script from "./ModalForgetPass.vue?vue&type=script&lang=js&"
export * from "./ModalForgetPass.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgetPass.vue?vue&type=style&index=0&id=03c03c25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c03c25",
  null
  
)

export default component.exports